export default "__VITE_ASSET__DKz293dn__"